export default "__VITE_ASSET__7eec34ca__"